import axios from 'axios';
import * as actionTypes from './actionTypes';
import {Base64} from 'js-base64';
import Axios from '../../axios-proas';
export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    }
}

export const authSuccess = (connectedUserId, login, userType, userRoles, access_data_key, access_data_assu_key, bailleur_id, enquete_id, logoutUrl, branding) => {
  
    return {
        type: actionTypes.AUTH_SUCCESS,
        connectedUserId: connectedUserId,
        login: login, 
        userType: userType, 
        userRoles: userRoles,
      access_data_key: access_data_key,
      access_data_assu_key: access_data_assu_key,
        bailleur_id: bailleur_id,
        enquete_id: enquete_id,
        logoutUrl: logoutUrl,
        logo: branding?.LogoResource,
        URL: branding?.WebAppUrl,
        libelleCourt : branding?.TenantName      
    }
}

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    }
}

export const logout = () => {

    localStorage.removeItem('token');
    localStorage.removeItem('expirationDate')
    localStorage.removeItem('userId')
    localStorage.removeItem('login')
    localStorage.removeItem('type')
    localStorage.removeItem('level')
    
    return {
        type: actionTypes.AUTH_LOGOUT
    }
}

export const checkAuthTimeout = (expirationTime) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout())
        }, expirationTime)  
    }
}

export const auth = (connectedUserId, login, userType, userRoles, access_data_key, access_data_assu_key, bailleur_id, enquete_id, tenant_branding, logoutUrl) => { 
    var branding = JSON.parse(tenant_branding)
    //console.log(branding)
    
    return dispatch => {
        dispatch(authStart());
      dispatch(authSuccess(connectedUserId, login, userType, userRoles, access_data_key, access_data_assu_key, bailleur_id, enquete_id, logoutUrl, branding))

    }
    
   

    //return dispatch => {
    //    dispatch(authStart());
    //    if (bailleur_id != null) {
    //        Axios.get('/api/tenants/' + bailleur_id + '/brandingnj', {
    //            headers: {
    //                'X-API-KEY-YOUNOV-CDN': 'a7f0a597-34e9-4e36-a019-ec3bd6af7e22'
    //            }
    //        })
    //            .then(response => {
    //                dispatch(authSuccess(connectedUserId, login, userType, userRoles, access_data_key, bailleur_id, enquete_id, logoutUrl, response.data))

    //            }).catch(err => {
    //                dispatch(authFail(err.response?.data?.error))
    //            })
    //    } else
    //    {
    //        dispatch(authSuccess(connectedUserId, login, userType, userRoles, access_data_key, bailleur_id, enquete_id, logoutUrl, null))
    //    }
       
    //}
}

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    }
}

